<template>
  <b-card class="white-container">
      <b-row>
        <b-col>
          <h4 id="churn-mm" class="card-title mb-4" @click="startExport">{{ title }}</h4>
        </b-col>
      </b-row>
      <loader v-if="loading"/>
      <v-server-table
          :ref="`${this.index}-table`"
          class="white-container px-0 pt-0"
          :url="url"
          :columns="columns"
          :options="getCustomOptions"
          @loaded="$emit('loaded', false);"
          @loading="$emit('loading', true)"
      >
        <template slot="beforeFilter" class="w-100">

          <ExportComponent v-if="enableExport && exportRequest" @export="startExport" v-model="targetMail"/>

        </template>
        <template slot="full_name_and_email" slot-scope="props">
          <router-link :to="{path: `/users/edit/${props.row.id}`, params: props.row}" target="_blank">
            <span class="text-capitaliloadingze">{{props.row.first_name}} {{props.row.last_name}} <br/>{{props.row.email}}</span>
          </router-link>
        </template>
        <template slot="id" slot-scope="props">
          <router-link :to="{path: `/users/edit/${props.row.id}`, params: props.row}" target="_blank">{{props.row.id}}
          </router-link>
        </template>
        <template slot="full_name" slot-scope="props">
          <span class="text-capitaliloadingze">{{props.row.first_name}} {{props.row.last_name}}</span>
        </template>
        <template slot="location" slot-scope="props">
          <column-location :row="props.row"/>
        </template>
        <template slot="created_at" slot-scope="props">
          <column-date :row="props.row" column="created_at" format="L"/>
        </template>
        <template slot="subscriptions" slot-scope="props">
          <column-subscriptions :row="props.row" column="subscriptions"/>
        </template>
        <template slot="renewal_date" slot-scope="props" v-if="props.row.subscriptions.length">
          <div v-for="(subscription, index) in props.row.subscriptions" :key="index">
            {{formatDate(subscription.subscription_end_date, 'L')}}
          </div>
        </template>
        <template slot="last_transaction" slot-scope="props">
          <div>{{props.row.transaction_last_date ? formatDate(props.row.transaction_last_date, 'L'): 'N/A'}}</div>
        </template>
        <template slot="ltv" slot-scope="props">
          <div>{{props.row.transaction_ltv ? formatToDollars(props.row.transaction_ltv) + ' USD' : 'N/A'}}</div>
        </template>
        <template slot="actions" slot-scope="props">
          <column-action
              :showDeleteButton="false"
              :route="{path: `/users/edit/${props.row.id}`, params: props.row}"/>
        </template>
        <template slot="current_subscription" slot-scope="props">
          <template v-if="props.row.subscription">
            <column-subscriptions :row="props.row" :initial-expand="true"name="subscription" column="current_subscription"/>
          </template>
          <template v-else>N/A</template>
        </template>
        <template slot="previous_subscription" slot-scope="props">
          <template v-if="props.row.previous_subscription">
            <column-subscriptions :row="props.row" :initial-expand="true" name="previous_subscription" column="current_subscription"/>
          </template>
          <template v-else>N/A</template>
        </template>
        <template slot="subscriptions" slot-scope="props">
          <column-subscriptions :row="props.row" name="subscriptions" column="current_subscription"/>
        </template>
        <template slot="date_changed" slot-scope="props">
          <template v-if="props.row.previous_subscription">
            {{formatDate(props.row.previous_subscription.subscription_end_date, 'L')}}
          </template>
          <template v-else>N/A</template>
        </template>
        <template slot="subscription_end_date" slot-scope="props">
          <template v-if="props.row.previous_subscription">
            {{formatDate(props.row.previous_subscription.subscription_planed_end_date, 'L')}}
          </template>
          <template v-else>N/A</template>
        </template>
      </v-server-table>
    </b-card>
</template>

<script>
import {Event} from "vue-tables-2";
import axios from "@/utils/axios";
import ExportComponent from "../table/ExportComponent";

export default {
  name: 'UsersTableOnCard',
  components: {ExportComponent},
  props: {
    url: {
      type: String,
      default: ''
    },
    columns: {
      type: Array
    },
    options: {
      type: Object
    },
    title: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    enableExport: {
      type: Boolean,
      default: false
    },
    exportRequest: {
      type: String,
      default: ''
    },
    params: {
      type: Object,
      default: null
    },
    index: {
      type: Symbol
    }
  },

  data () {
    return {
      targetMail: null,
      initiated: false,
    }
  },
  mounted () {
    Event.$on('vue-tables.loaded', ({data}) => {
      if (!this.initiated && this.params) {
        this.applyFilters()
        this.initiated = true
      }
    });
  },
  methods: {
    startExport () {
      if(this.targetMail) {
        this.getData(`${this.exportRequest}&email=${this.targetMail}`).then(({data}) => {
          if(data.success) {
            this.$noty.success(this.$t('global.link_sent'));
          } else {
            this.$noty.error(this.$t('global.task_already_exist'));
          }
        }
        )
      }},
    applyFilters () {
      if (this.params) {
        Event.$emit(`vue-tables.filter::custom`, this.params);
      }
    }
  },
  computed: {
    getCustomOptions () {
      return {
        ...this.options,
      }
    }
  }
}
</script>
